import axios from 'axios';

interface IInitOptions {
  apiKey: string;
  accessToken: string;
  timeout?: number;
}

class AxiosWrapper {
  public static init({ apiKey, accessToken, timeout = 30000 }: IInitOptions) {
    return axios.create({
      timeout,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'x-api-key': apiKey,
      },
    });
  }
}

export default AxiosWrapper;
